module.exports = __webpack_public_path__ + "img/RLegionary64_ua.bb19c8aa.webp";